<template>
  <div class="homepage-wrapper">
    <main role="main">
      <!-- Multi-Product Hero Graphic Section (Transparent Background) -->
      <div class="hero-product-container text-center py-2">
        <img
          src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/multiproduct.jpg"
          alt="Danone Big Ten Football Products"
          class="img-fluid d-none d-md-block mx-auto hero-product-img"
        />
        <img
          src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/multiproduct.jpg-mb.jpg"
          alt="Danone Big Ten Football Products"
          class="img-fluid d-md-none mx-auto hero-product-img-mb"
        />
      </div>

      <!-- Hero Copy & CTA Section with Player Image at Right Edge of Browser -->
      <div class="hero-intro-section position-relative py-4 overflow-hidden">
        <!-- Football Player Graphic (Placed at Right Edge of Browser in Background) -->
        <div class="player-bg-container d-none d-lg-block">
          <img
            src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/player.png"
            alt="Football Player"
            class="player-browser-edge-img"
          />
        </div>

        <div
          class="container position-relative hero-content-zindex text-center"
        >
          <!-- H1 Main Headline -->
          <h1 class="main-headline mb-3">
            {{ $t('Home.BannerTitle') }}
          </h1>

          <!-- Brief Description Paragraph -->
          <p
            class="hero-description mx-auto mb-4"
            style="max-width: 950px"
            v-html="$t('Home.BannerDesc')"
          ></p>

          <!-- Ready To Submit Block -->
          <div class="readytosubmit-block mt-4">
            <h3 class="smaller-header mb-2">
              {{ $t('Home.ReadytoSubmitTitle') }}
            </h3>
            <p
              class="subheader-text mb-4"
              v-html="$t('Home.ReadytoSubmitDesc')"
            ></p>

            <!-- Slanted Primary CTA Button -->
            <div class="mb-4">
              <router-link to="/Upload" class="btn btn-primary-slanted">
                <span class="btn-text-unskew">{{
                  $t('Home.GetStartedBtn')
                }}</span>
              </router-link>
            </div>

            <!-- Quick Links -->
            <div class="quick-links">
              <div class="mb-2">
                <span
                  class="blue-link"
                  v-html="$t('Home.ParticipatingProductLink')"
                ></span>
              </div>
              <div>
                <span
                  class="blue-link"
                  v-html="$t('Home.HavingTroubleLink')"
                  @click="handleLinkClick"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <!-- How to Participate Section with Background Image -->
        <div class="how-to-participate-bg py-5">
          <div class="container py-4">
            <h2 class="section-title text-center text-white mb-5">
              {{ $t('Home.HowToParticipateTitle') }}
            </h2>

            <!-- Desktop 3 Steps Row -->
            <div
              class="row align-items-start justify-content-center text-center d-none d-md-flex steps-desktop-row"
            >
              <!-- Step 1: BUY -->
              <div class="col-md-2 step-card">
                <h3 class="step-title mb-3">{{ $t('Home.ShopTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.ShopDetail')"></p>
              </div>

              <!-- Arrow 1 -->
              <div
                class="col-md-2 d-flex justify-content-center align-items-center arrow-container pt-3"
              >
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/o-arrow.png"
                  alt="arrow"
                  class="img-fluid arrow-img"
                />
              </div>

              <!-- Step 2: UPLOAD -->
              <div class="col-md-3 step-card">
                <h3 class="step-title mb-3">{{ $t('Home.SnapTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.SnapDetail')"></p>
              </div>

              <!-- Arrow 2 -->
              <div
                class="col-md-2 d-flex justify-content-center align-items-center arrow-container pt-3"
              >
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/x-arrow.png"
                  alt="arrow"
                  class="img-fluid arrow-img"
                />
              </div>

              <!-- Step 3: EARN -->
              <div class="col-md-2 step-card">
                <h3 class="step-title mb-3">{{ $t('Home.GetTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.GetDetail')"></p>
              </div>
            </div>

            <!-- Mobile Stacked Steps -->
            <div class="d-md-none text-center steps-mobile-wrapper px-3">
              <div class="step-card mb-3">
                <h3 class="step-title mb-2">{{ $t('Home.ShopTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.ShopDetail')"></p>
              </div>

              <div class="my-3">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/o-arrow.png"
                  alt="arrow"
                  class="img-fluid arrow-img-mb"
                />
              </div>

              <div class="step-card mb-3">
                <h3 class="step-title mb-2">{{ $t('Home.SnapTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.SnapDetail')"></p>
              </div>

              <div class="my-3">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/x-arrow.png"
                  alt="arrow"
                  class="img-fluid arrow-img-mb"
                />
              </div>

              <div class="step-card">
                <h3 class="step-title mb-2">{{ $t('Home.GetTitle') }}</h3>
                <p class="step-desc" v-html="$t('Home.GetDetail')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SEO Page Copy Section -->
      <!-- <div class="container py-5 text-center seo-copy-container">
        <h3 class="seo-heading mb-3">{{ $t('Home.SeoTitle') }}</h3>
        <p class="seo-paragraph mx-auto" style="max-width: 920px;" v-html="$t('Home.SeoDesc')"></p>
      </div> -->
    </main>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');
        if (href && href.startsWith('/')) {
          event.preventDefault();
          this.$router.push(href);
        }
      }
    },
  },
};
</script>

<style scoped>
/* Page-level layout overrides if any */
</style>
